export function buildLuxorPromptMessage(
  importedContent: string,
  freeText: string
): string {
  const parts = [importedContent.trim(), freeText.trim()].filter(Boolean);
  return parts.join("\n\n");
}
